module.exports = __webpack_public_path__ + "static/media/23.0c74bec2.mp3";